import OrderFormContainer from './orderForm/OrderForm.container';

const OrderForm = () => <OrderFormContainer />;

export default OrderForm;
